import { palette } from "../theme";

// Same windows as the dashboard summary on the server
export const DUE_SOON_DAYS = 7;
export const STARTING_SOON_DAYS = 7;
export const LONG_OVERDUE_DAYS = 30;
// Keeps "Today in the Field" current on a dashboard left open
export const AUTO_REFRESH_MINUTES = 5;

export const WO_STATUS_COLORS: Record<string, string> = {
  NEW: palette.dashBlue,
  IN_PROGRESS: palette.dashOrange,
  IN_REVIEW: palette.dashPurple,
  STANDBY: palette.dashRed,
  DELAYED: palette.dashCyan,
  DONE: palette.dashGreen,
};

export const SERVICE_CHART_COLORS = [
  palette.dashBlue,
  palette.dashGreen,
  palette.dashOrange,
  palette.dashPurple,
  palette.dashRed,
  palette.dashCyan,
] as const;
